<wiz-vgroup class="section-container" height="100%" width="100%">

  <wiz-label #lblTitle  height="30px" width="100%" class="titleLabel" [wizLabel]="titleStr"></wiz-label>

    <wiz-label  #lblDetail [wizLabel]="contentStr"
    [wizTextBehavior]="'wordWrap'" width="100%">
    </wiz-label>

  <wiz-hgroup height="100%" width="100%" horizontalAlign="center">
    <ng-container #rendererContainer></ng-container>
  </wiz-hgroup>

  <wiz-hgroup horizontalAlign="end" height="45px" width="100%">
    <wiz-button #goodButton [wizLabel]="goodLabel" minWidth='50px'></wiz-button>
    <wiz-button #badButton [wizLabel]="badLabel" minWidth='50px' *ngIf="showBadButton"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
